import { api } from "./api";

export interface MissingVm {
    id: string;
    name: string;
    alias: string;
    ip: string;
}

export interface SyncResponse {
    servers: any[];
    inventory_complete: boolean;
    requires_deletion_confirmation: boolean;
    missing_vms: MissingVm[];
    deleted_vm_ids: string[];
}

// A API antiga respondia apenas com a lista de servidores; o fallback evita quebra
// enquanto front e back nao estao na mesma versao.
const normalize = (data: any): SyncResponse => ({
    servers: Array.isArray(data) ? data : data?.servers ?? [],
    inventory_complete: data?.inventory_complete ?? true,
    requires_deletion_confirmation: data?.requires_deletion_confirmation ?? false,
    missing_vms: data?.missing_vms ?? [],
    deleted_vm_ids: data?.deleted_vm_ids ?? [],
});

export const syncVms = async (): Promise<SyncResponse> => {
    const response = await api.get('/sync/');
    return normalize(response.data);
};

export const confirmVmDeletion = async (serverIds: string[]): Promise<SyncResponse> => {
    const response = await api.post('/sync/', {
        confirm_delete: true,
        server_ids: serverIds,
    });
    return normalize(response.data);
};
